const getSelection = (context, object) => {
  context.commit("TEMPLATING_SELECTION_UPDATED", object);
};
const getSelectedDefinition = (context, object) => {
  context.commit("TEMPLATING_SELECTED_DEFINITION_UPDATED", object);
};

export default {
  getSelection,
  getSelectedDefinition,
};
